"use client";

import { IBlogTag } from "@/api/AppApi/services/blogs/interfaces/IBlogs";
import { useSearchParams } from "next/navigation";
import { useBlogPushQuery } from "@/utils/functions/useBlogPushQuery";
import { useMemo, useCallback } from "react";

interface props {
  tag: IBlogTag;
  fkey: string;
}
const Tag: React.FC<props> = ({ tag, fkey }) => {
  const searchParams = useSearchParams();
  const { pushQueryToRouter } = useBlogPushQuery();

  const selectedTags = useMemo(() => {
    const tagsParam = searchParams?.get(fkey) ?? "";
    return tagsParam ? tagsParam.split(",").filter(Boolean) : [];
  }, [searchParams, fkey]);

  const isActive = selectedTags.includes(tag?.key);

  const toggleTag = useCallback(() => {
    const newTags = isActive
      ? selectedTags.filter((t) => t !== tag?.key)
      : [...selectedTags, tag?.key];

    pushQueryToRouter(
      [{ name: fkey, val: newTags.length > 0 ? newTags.join(",") : "" }],
      true
    );
  }, [isActive, selectedTags, tag?.key, fkey, pushQueryToRouter]);

  return (
    <div
      className={`tag ${isActive ? "active" : ""}`}
      onClick={toggleTag}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") toggleTag();
      }}
    >
      {isActive && <span style={{ marginInlineEnd: 6 }}>✕</span>}
      {tag?.value}
    </div>
  );
};

export default Tag;
